import normalize from 'json-api-normalizer';

import Resource from './resource';

export default class AdditionalResource {
	static from (jsonapi) {
		let key = 'additionalResources'
		let normalizedJSONapi = normalize(jsonapi);
		if (!(Object.keys(normalizedJSONapi).includes(key))) return null;

		let keys = Object.keys(normalizedJSONapi[key]);
		if (keys.length > 0 && Array.isArray(jsonapi.data)) {
			let retVal = {};
			keys.forEach( function ( id ) {
				retVal[id] = AdditionalResource.make(normalizedJSONapi[key][id], normalizedJSONapi);
			});
			return retVal;
		} else return AdditionalResource.make(normalizedJSONapi[key][keys[0]], normalizedJSONapi);
	}

	static make(jsonapi, normalizedJSONapi) {
		const { id, attributes } = jsonapi;

		attributes.resource = {}
		if (attributes.resourceId && normalizedJSONapi['resources'][attributes.resourceId]) {
			attributes.resource = Resource.make(normalizedJSONapi['resources'][attributes.resourceId], normalizedJSONapi);
		}

		return new AdditionalResource ( Object.assign( {}, { id: id }, attributes ) );
	}


	constructor ({ id, programId, url, description, resourceId, resource, position, additionalResourceCategoryId, viewCount, lastDownloadedAt }) {
		this.id             = id ? id : '';
		this.program_id     = programId ? programId : -1;
		this.url            = url ? url : '';
		this.description    = description ? description : '';
		this.resource_id	= resourceId ? resourceId : -1;
		this.file			= {};
		this.resource		= resource ? resource : {};
		this.position		= position ? position : 0;
		this.additional_resource_category_id	= additionalResourceCategoryId;
		this.view_count		= viewCount ? viewCount : 0;
		this.last_downloaded_at	= lastDownloadedAt ? lastDownloadedAt : null;
	}

	toJSONapi () {

		let attributes = Object.assign({}, this);

		if (attributes.id < 1) delete attributes.id;
		delete attributes.resource;

		return { data: { type: 'additional_resources', id: this.id, attributes: attributes } };
	}
}
